import { useAtomValue } from "jotai";
import { questionnaireErrorAtom } from "../state/questionnaireErrorAtom";

/**
 * Get a single question's error. Only re-renders when this error changes.
 *
 * @example const error = useError('business_type');
 */
export function useError(questionName: string): string | undefined {
  return useAtomValue(questionnaireErrorAtom(questionName));
}
